import { Directive, HostListener } from '@angular/core';
import { SidebarStorageService   } from '@shared/services';

@Directive({
  selector: '[toggleSidebar]',
  standalone: false
})
export class ToggleSidebarDirective {
  constructor(private sidebarStorageService: SidebarStorageService) {}
  @HostListener('document:click', ['$event']) onClick(event: Event) {
    const target = event.target as HTMLElement;
    if (target.classList.contains('mobile-toggler') && target.classList.contains('icon-bars') ||
        target.classList.contains('sidebar-overflow')) {
      event.stopImmediatePropagation();
      this.sidebarStorageService.toggleSidebarState();
      document.getElementById('portal-sidebar')?.classList.toggle('mini-sidebar-xs');
    }
  }
}
